/* CATMATIK — règle du cadeau : un cadeau offert par litière, jamais plus.
 *
 * Écrit le 22/09/2026 après la commande #1006 : une litière, deux cadeaux.
 * Le formulaire de la fiche produit poste sur /cart/add, qui est cumulatif :
 * changer de cadeau puis revalider empilait une deuxième ligne à 0 €. Le panier
 * du thème, lui, ignore complètement la notion de cadeau (aucune occurrence de
 * « cadeau » dans side-cart, main-cart, custom.js ni custom-async.js).
 *
 * Ce script est le filet, côté panier, indépendant du chemin emprunté :
 *   - au plus UNE ligne cadeau, la plus récemment ajoutée ;
 *   - sa quantité ne dépasse jamais le nombre de litières au panier ;
 *   - aucune litière au panier : le cadeau est retiré.
 * Il couvre donc aussi la quantité montée à la main dans le panier, la litière
 * supprimée en gardant le cadeau, et l'ajout direct par /cart/add?id=…
 *
 * Depuis le 22/09/2026, la quantité de cadeau est alignée sur le nombre de
 * litières : le pack de deux en reçoit deux. Mettre `PLAFOND_SEULEMENT` à true
 * pour revenir à un simple plafond, sans jamais remonter la quantité.
 *
 * Limite connue : le permalien /cart/<variante>:<n> va droit au paiement sans
 * charger de page, donc sans passer par ici. Seule une vraie réduction Shopify
 * « acheté, offert » fermerait ce cas, au prix d'une refonte du sélecteur.
 */
(function () {
  var LITIERES = ['litiere-automatique-fermee-anti-odeur'];
  var PLAFOND_SEULEMENT = false;   // un cadeau par litière : deux litières, deux cadeaux

  function estCadeau(item) {
    return item.product_type === 'Cadeau' || /^cadeau-/.test(item.handle || '');
  }
  function estLitiere(item) {
    return LITIERES.indexOf(item.handle) !== -1;
  }

  var interne = false;      // nos propres appels ne doivent pas se déclencher eux-mêmes
  var file = Promise.resolve();
  function enFile(fn) {
    file = file.then(fn).catch(function () {});
    return file;
  }

  function panier() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* Renvoie une promesse : true si le panier a été corrigé. */
  function corriger() {
    return panier().then(function (c) {
      var items = c.items || [];
      var cadeaux = items.filter(estCadeau);
      if (!cadeaux.length) return false;

      var litieres = items.filter(estLitiere).reduce(function (n, i) { return n + i.quantity; }, 0);
      var garde = cadeaux[cadeaux.length - 1];   // l'ordre du panier suit l'ordre d'ajout
      var updates = {};

      cadeaux.forEach(function (it) {
        if (it.key !== garde.key) updates[it.key] = 0;
      });
      var voulu = PLAFOND_SEULEMENT ? Math.min(garde.quantity, litieres) : litieres;
      if (voulu !== garde.quantity) updates[garde.key] = voulu;

      if (!Object.keys(updates).length) return false;

      interne = true;
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return true; })
        .catch(function () { return false; })
        .then(function (ok) { interne = false; return ok; });
    }).catch(function () { return false; });
  }

  /* Le tiroir et la page panier affichent encore l'état d'avant la correction :
     on redemande le balisage au thème plutôt que de recharger la page. */
  function rafraichir() {
    var surPanier = /^\/cart(\/|$)/.test(window.location.pathname);
    if (surPanier) { window.location.reload(); return; }
    fetch('/?sections=side-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
          window.ajaxCart.load({ sections: sections }, false);
        }
      })
      .catch(function () {});
  }

  function corrigerPuisRafraichir() {
    return enFile(function () {
      return corriger().then(function (change) { if (change) rafraichir(); return change; });
    });
  }

  /* ── 1. À l'ouverture de la page : un panier hérité peut déjà être invalide ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', corrigerPuisRafraichir);
  } else {
    corrigerPuisRafraichir();
  }

  /* ── 2. Après chaque modification du panier, quelle qu'en soit l'origine ── */
  var ROUTES = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  function concerne(url) {
    if (interne) return false;
    for (var i = 0; i < ROUTES.length; i++) if (String(url).indexOf(ROUTES[i]) !== -1) return true;
    return false;
  }

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var vise = concerne(url);
      var p = _fetch.apply(this, arguments);
      if (vise) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          /* Le thème vient de rendre le tiroir avec la réponse : on corrige
             derrière lui, puis on lui redonne un balisage à jour. */
          setTimeout(corrigerPuisRafraichir, 60);
        }).catch(function () {});
      }
      return p;
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (concerne(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) setTimeout(corrigerPuisRafraichir, 60);
      });
    }
    return _open.apply(this, arguments);
  };

  /* ── 3. Dernier verrou : avant de partir au paiement ── */
  document.addEventListener('click', function (ev) {
    var cible = ev.target && ev.target.closest
      ? ev.target.closest('[name="checkout"], a[href*="/checkout"], .f8vl [type="submit"]')
      : null;
    if (!cible) return;
    if (cible.getAttribute('data-cmk-verifie') === 'oui') return;
    ev.preventDefault();
    ev.stopPropagation();
    corrigerPuisRafraichir().then(function (change) {
      cible.setAttribute('data-cmk-verifie', 'oui');
      /* Panier corrigé sous les yeux du visiteur : on le laisse voir le nouveau
         contenu plutôt que de l'emmener payer autre chose que ce qu'il voyait. */
      if (!change) cible.click();
    });
  }, true);

  window.cmkCadeaux = { corriger: corrigerPuisRafraichir };
})();
